module.exports = __webpack_public_path__ + "img/rule.34973422.png";